<template>
  <div class="page">
    <img :src="cdnresources+'/prod/images/hunan2021/productdesBox.png'" />
    <div style="padding:0 15px;">
      <div class="centent">
        <img class="content-title" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_02.png'" />1、适用人群：湖南省基本医保参保人（含省本级、各市州），包括城镇职工、城乡居民
        <br/>2、被保险人年龄限制：不限
        <br/>3、健康状况：不限
        <br/>4、保险期间：一年
        <br/>5、交费方式：趸交（一次性交费）
        <br/>6、保费：139元/人/年。
        <img class="content-title" style="margin-top: 15px" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_03.png'" />
      </div>
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_04.png'" />
      <img style="margin-top:20px" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_05.png'" />
      <!-- <div class="context">
        <div class="context-title">
          1.关于“湖南爱民保”（以下简称“本产品”）使用基本医疗保险的约定
        </div>
        <div class="context-text">
          对于符合湖南省各市州（含省本级）社会基本医疗保险目录内的医疗费用，若被保险人未先通过湖南省社会基本医疗保险结算的，保险人不承担给付保险金的责任。
自被保险人不再享受湖南省各市州（含省本级）社会基本医疗保险待遇之日起，保险人将不再承担给付保险金的责任。
        </div>
        <div class="context-title">
          2.关于被保险人既往症¹¹的约定
        </div>
        <div class="context-text">
          如被保险人在保险合同生效前（2021年10月18日-2021年12月25日投保的保单生效日2021年12月26日0时，2021年12月26日-2021年12月31日投保的保单生效日2022年1月1日0时）已罹患以下疾病，并在保险期间内因以下疾病产生的本产品保险责任范围内的医疗费用，经湖南省各市州（含省本级）社会基本医疗保险结算并扣除保险责任对应的年度免赔额后，按照非约定既往症人群赔付比例的40%赔付。
        </div>
        <div class="context-title">
          3.关于异地就医的约定
        </div>
        <div class="context-text">
          对于符合基本医疗保险转诊备案或常住（驻）异地备案的被保险人，在湖南省外医疗机构（仅限中国大陆境内的二级及以上基本医疗保险定点医院）就医，经湖南省社会基本医疗保险结算后属于本产品保险责任范围的医疗费用，按本产品保障方案对应的赔付比例的80%进行赔付。对于未经转诊备案或转诊备案手续不符合湖南省基本医疗保险异地就医规定的被保险人，保险人不承担给付保险金的责任。
        </div>
        <div class="context-title">
          4.关于就医时间与保险期间的约定
        </div>
        <div class="context-text">
          保险责任期间以被保险人就医时间（入院日期）为准：
          <br/>4.1.被保险人同一次住院（指一次出入院结算），在本产品保单生效之日前入院，在本产品保单生效当日及之后出院的，对于实际发生的不在保险期内的医疗费用，保险人不承担给付保险金的责任。
          <br/>4.2.被保险人同一次住院，在本产品保险期间内入院，在保险期间届满之日后被保险人治疗仍未结束的，保险人所承担的保险金给付责任自保险期间届满之时终止。
        </div>
      </div> -->
      <img class="content-title" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_06.png'" />
      <div class="context">
        <div class="context-title">
          1.因下列情形之一，导致被保险人支出医疗费用的，保险人不承担给付保险金的责任：
        </div>
        <div class="context-text">
          （1）应当由第三者负担的；
          <br/>（2）应当从工伤保险、生育保险中支付的；
          <br/>（3）应当由公共卫生负担的；
          <br/>（4）在境外（含香港特别行政区、澳门特别行政区、台湾地区及境外国家）就医发生的医疗费用；
          <br/>（5）被保险人在保险期间停止参加湖南省各市州（含省本级）社会基本医疗保险的，在其停止享受基本医疗保障待遇期间发生的医疗费用；
          <br/>（6）基本医疗保险完全不予报销的医疗费用，如各种美容、整形、非功能性矫形、减肥、非医学必需的激素治疗，治疗雀斑、脱痣、护肤、镶牙、洁牙，配镜、装配假眼、假肢、助听器等发生的费用；
          <br/>（7）非疾病治疗项目类，如各种健康体检、婚前检查、旅游体检、职业体检、出境体检等费用；
          <br/>（8）各种不育（孕）症、性功能障碍的诊疗项目（如：男性不育、女性不孕检查、治疗费，鉴定性病检查、治疗费，违反计划生育的一切医疗费用），各类医疗鉴定、各种教学性、科研性和临床验证性的诊疗项目费用；
          <br/>（9）膏方费用以及以下主要起滋补保健用途以及含国家珍贵、濒危野生动植物药材的药品和中药饮片费用，上述药品和中药饮片具体包括：阿胶、白糖参、朝鲜红参、穿山甲（醋山甲、炮山甲）、玳瑁、冬虫夏草、蜂蜜、狗宝、龟鹿二仙胶、哈蟆油、海龙、海马、猴枣、酒制蜂胶、羚羊角尖粉（羚羊角镑片、羚羊角粉）、鹿茸（鹿茸粉、鹿茸片）、马宝、玛瑙、牛黄、珊瑚、麝香、天山雪莲、鲜石斛（铁皮石斛）、西红花（番红花）、西洋参、血竭、燕窝、野山参、移山参、珍珠、紫河车、各种动物脏器（鸡内金除外）和胎、鞭、尾、筋、骨；
          注：以上所列药品和中药饮片均包括生药及炮制后的药材及饮片。
          <br/>（10）预防性疫苗和避孕药品费用，主要用于治疗脱发、减肥、美容、戒烟、戒酒等药品费用；
          <br/>（11）除当地基本医疗保险相关制度以外，其他当地法律、法规、政策、文件及本产品适用条款规定不予支付的医疗费用，保险人不承担给付保险金责任。
        </div>
        <div class="context-title">
          2、针对“特定药品费用医疗保险金”
        </div>
        <div class="context-text">
          对于使用本产品约定的特定药品的被保险人，如存在下列情形的，保险人不承担给付保险金的责任：
          <br/>（1）药品处方的开具与本产品《“湖南爱民保”特定药品目录》（详见附件一）的支付范围不符；
          <br/>（2）未由本产品基本医保定点医院或其他指定医院的专科医生开具处方，或未在指定医院或指定药店购买的药品；
          <br/>（3）每次药品处方开具时间超过一个月的，对超出一个月部分金额的药品费用；
          <br/>（4）药品处方的开具与国家食品药品监督管理总局批准的该药品说明书中所列明的适应症用法用量不符或相关医学材料不能证明被保险人所患疾病符合使用特定药物的指征；
          <br/>（5）被保险人符合慈善援助用药申请，但因被保险人未提交相关申请或者提交的申请材料不全，导致援助项目申请未通过而发生的药品费用；被保险人通过援助审核，但因被保险人原因未领取援助药品，视为被保险人自愿放弃本产品相关保险权益；
          <br/>（6）进行未经科学或者医学认可的试验性或者研究性治疗。
        </div>
      </div>
      <img class="content-title" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_07.png'" />
      <div class="context">
        <div class="context-title">
          1.特殊病种门诊
        </div>
        <div class="context-text">
          特殊病种门诊所涵盖疾病范围以医保部门发布的文件为准。若有关部门对目录进行调整的，本产品将对应调整，相关信息将在“湖南爱民保”微信公众号公布。
        </div>
        <div class="context-title">
          2.罕见病
        </div>
        <div class="context-text">
          罕见病范围以2018年5月22日国家卫生健康委、科技部、工业和信息化部、国家药品监督管理局和国家中医药管理局等五部门联合发布的《第一批罕见病目录》[国卫医发〔2018〕10号]为准，详见附件三。若有关部门对目录进行调整的，本产品将对应调整，相关信息将在“湖南爱民保”微信公众号公布。
        </div>
        <div class="context-title">
          3.特定药品
        </div>
        <div class="context-text">
          （1）药品目录：《“湖南爱民保”特定药品目录》（详见附件一）。 
          <br/>（2）处方要求：使用药品的药物处方必须在保险期间内由基本医保定点医院的专科医生开具，属于被保险人当前治疗必备的药品，且每次处方药剂量与国家食品药品监督管理总局批准的该药品说明书中所列明的适应症用法用量相符，处方未超出药品说明书的适应症范围。处方有效期的规定按国家或当地政府部门相关处方管理规定。 
          <br/>（3）处方审核：本产品将按照约定的保险责任对申请人进行药品处方审核，如果审核出现以下特殊问题，保险人将有权要求申请人补充其他与药品处方审核相关的医学材料。药品处方审核的特殊情况包括： 
          <br/>  ①申请人提交特定药品领取申请时所提交的与被保险人相关的医学材料，不足以支持药品处方审核； 
          <br/>  ②医学材料中相关的科学方法验证检验报告结果，不支持药品处方的开具。
        </div>
        <div class="context-title">
          4.基本医保定点医院
        </div>
        <div class="context-text">
          中华人民共和国境内（不包括香港、澳门、台湾地区）的基本医疗保险定点医院，具体指湖南省基本医疗保险定点医疗医院（不包括其附属的国际医疗、特需医疗、贵宾医疗、外宾医疗或者相类似的部门和科室），且应符合下列所有条件：
          <br/>（1）拥有合法经营执照；
          <br/>（2）设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；
          <br/>（3）有合格的医生和护士提供全日二十四小时的医疗和护理服务；
          <br/>（4）非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。
        </div>
        <div class="context-title">
          5.社会基本医疗保险
        </div>
        <div class="context-text">
          包括但不限于湖南省城镇职工（含省本级）基本医疗保险、湖南省城乡居民基本医疗保险、城镇职工（含省本级）大病互助、湖南省城乡居民大病医疗保险、医疗救助等政府主办的医疗保险。
        </div>
        <div class="context-title">
          6.个人自负
        </div>
        <div class="context-text">
          在医保基金支付范围内的费用由各类医保基金按规定的额度或比例结付后，按规定由被保险人负担的费用。包括医疗保险起付线、按比例自付部分、及医疗保险报销封顶线之上的部分，不包括部分自付费用和完全自付费用。
        </div>
        <div class="context-title">
          7.专科医生
        </div>
        <div class="context-text">
          专科医生应当同时满足以下四项资格条件：
          <br/>（1）具有有效的中华人民共和国《医师资格证书》；
          <br/>（2）具有有效的中华人民共和国《医师执业证书》，并按期到相关部门登记注册；
          <br/>（3）具有有效的中华人民共和国主治医师或者主治医师以上职称的《医师职称证书》；
          <br/>（4）确诊或开具处方时，属于与处方适应症治疗相关的临床科室。
        </div>
        <div class="context-title">
          8.指定药店
        </div>
        <div class="context-text">
          指湖南省具备药品销售资质的药店，其中可以提供特定药品增值服务的指定药店详见附件二。
        </div>
        <div class="context-title">
          9.年度免赔额
        </div>
        <div class="context-text">
          指在本产品保险期间内，应由被保险人自行承担，本产品不予赔付的部分。本产品各保障责任免赔额分别计算，不共用。
        </div>
        <div class="context-title">
          10.健康管理服务
        </div>
        <div class="context-text">
          详见参保页面的《“湖南爱民保”健康管理服务手册》。
        </div>
        <div class="context-title">
          11.既往症
        </div>
        <div class="context-text">
          （一）恶性肿瘤（含白血病、淋巴瘤）
          指恶性细胞不受控制的进行性增长和扩散，浸润和破坏周围正常组织,可以经血管、淋巴管和体腔扩散转移到身体其它部位,病灶经组织病理学检查(涵盖骨髓病理学检查）结果明确诊断,临床诊断属于世界卫生组织（WHO，WorldHealthOrganization）《疾病和有关健康问题的国际统计分类》（ICD）的恶性肿瘤类别及《国际疾病分类肿瘤学专辑》第三版（ICD-O-3）的肿瘤形态学编码属于（1）动态未定性肿瘤；（2）原位癌和非侵袭性癌；（3）恶性肿瘤（原发性）；（4）恶性肿瘤（转移性）；（5）恶性肿瘤（原发性或转移性未肯定）范畴的疾病。
          <br/>（二）慢性肾功能不全（非透析治疗）
          指由多种原因导致的肾功能下降，使身体在排泄代谢废物和调节水电解质、酸碱平衡等方面出现紊乱的临床综合症后群。应同时满足以下条件：（1）血清肌酐（Scr）＞176μmol/L；（2）内生肌酐清除率（Ccr）＜80ml/min；③GFR＜90[ml/（min/1.73m2）]。
          <br/>（三）慢性肾功能衰竭（尿毒症期）
          尿毒症期为慢性肾功能衰竭的晚期阶段，一般是指慢性肾脏病的4期和5期。此时患者的肾脏无法发挥正常的功能，导致患者出现水、电解质酸碱平衡紊乱和肾脏内分泌功能失调，还会出现代谢终末产物和毒性物质在体内大量潴留，从而引起一系列症状和体征。患者经诊断后已经进行规律性透析治疗或实施了肾脏移植手术。规律性透析是指每周进行血液透析或每天进行腹膜透析。
          <br/>（四）肝硬化
          指由于一种或多种病因长期作用于肝脏而导致在肝细胞广泛坏死基础上产生肝脏纤维组织弥漫性增生，形成结节、假小叶，进而使肝脏正常结构和血供遭到破坏的一种慢性、进行性、弥漫性的肝病终末阶段。引起肝硬化的病因很多，例如：病毒性肝硬化、胆汁淤积性肝硬化、自身免疫性肝硬化、血吸虫性肝硬化、酒精性肝硬化、隐源性肝硬化等。超声影像学提示：肝实质回声增强、增粗，肝质地变硬，肝脏表面凹凸不平，不光滑(或)脾大，伴有门静脉高压征，而无其他原因解释。
          <br/>（五）肝功能不全
          指因慢性肝脏疾病导致肝功能衰竭，有下列并发症之一者：严重感染、胸水或腹水、上消化道出血、肝性脑病、肝肾综合症；并符合以下标准之一：（1）B超或CT影像学证实，脾增大，食道或胃底静脉曲张或腹水征（+），少数可出现肝性胸水；（2）肝活检组织检查见假小叶形成；（3）检查指标持续异常：凝血功能异常，氨基转移酶水平升高、胆红素水平升高。
          <br/>（六）缺血性心脏病（含冠心病、心肌梗死）
          冠状动脉粥样硬化性心脏病（简称冠状动脉心脏病或冠心病,有时被称为缺血性心脏病或冠状动脉病)，是指由于冠状动脉发生粥样硬化引起管腔狭窄或闭塞，导致心肌缺血、缺氧或坏死而出现胸痛、胸闷等不适的一种缺血性心脏病。本产品定义的冠心病指以下三类：（1）心肌梗死型；（2）缺血性心肌病型；（3）猝死型。
          心肌梗死指由于冠状动脉闭塞或梗阻引起部分心肌严重的持久性缺血造成急性心肌坏死。
          需满足下列标准至少三项：（1）缺血性胸痛＞15分钟，含服硝酸甘油缓解不明显；（2）心电图提示新发或一过性ST压低≥0.1mV，或T波倒置≥0.2mV；（3）超声心动图有典形性节段性改变；（4）以往冠状动脉造影阳性，狭窄≥50％；（5）有明确急性心肌梗塞病史。
          <br/>（七）慢性心功能不全（心功能III级及以上）
          指各种原因导致心脏泵血功能受损，心排血量不能满足全身组织基础代谢需要的综合征，当心功能不全出现呼吸困难、活动受限、体液潴留等临床症状时即称为心力衰竭。
          应符合以下标准至少三项：（1）基础心脏病变；（2）NYHA心功能III级心脏病患者体力活动明显受限，休息时无症状，但小于一般体力活动即可引起过度疲劳、心悸、气喘或心绞痛。或NYHA心功能IV级心脏病患者不能从事任何体力活动，休息状态下也出现心衰症状，体力活动后加重；（3）心电图、负荷试验、X线、超声心动图等客观检查评估心脏病变C级及以上；（4）心脏射血分数（EF）＜50%；（5）B型钠尿肽（BNP）＞100pg/ml。
          <br/>（八）脑梗死、脑出血
          指因脑血管的突发病变引起脑血管出血、栓塞或梗塞，须由头颅断层扫描（CT）、核磁共振检查（MRI）等影像学检查证实,并导致神经系统永久性的功能障碍，同时符合以下三项标准：（1）急性起病（少数可亚急性起病），临床表现为局灶性神经功能缺失（如肢体瘫痪、感觉障碍、颅神经障碍、失语等），甚至伴有意识障碍；（2）经CT、MRI或CSF检查确诊的脑梗死、脑出血及蛛网膜下腔出血；（3）一肢（含）以上肢体肌力3级（含）以下；语言能力完全丧失，或严重咀嚼吞咽功能障碍；自主生活能力完全丧失，无法独立完成六项基本日常生活活动中的两项。
          <br/>（九）罕见病（同释义2）
        </div>
      </div>
      <img class="content-title" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_08.png'" />
      <div class="context">
        <div class="context-text">
          保险人有权在医保部门指导下将基本医保政策范围内的医疗费用与医保政策范围外的医疗费用（包括药品、诊疗服务项目、医用材料）通过动态调整纳入本产品保险责任范围，将存在滥用倾向、疗效不明确、主要起滋补保健用途的药品、诊疗服务项目及医用材料的费用列入本产品的责任免除范围。
        </div>
      </div>
      <div class="fujian">
        <span class="line"></span><span>附件一 “湖南爱民保”特定药品目录</span>
      </div>
      <img style="margin-bottom:10px" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_09.png'" />
      <div class="context">
        <div class="context-text">
          说明：为更好地向被保险人提供保障，结合湖南省基本医疗保险、大病保险药品目录调整及市场变化等情况，本产品保留对《“湖南爱民保”特定药品目录》调整的权力。如药品目录有调整，相关信息将在“湖南爱民保”微信公众号公布。
        </div>
      </div>
      <!-- <div class="fujian">
        <span class="line"></span><span>附件二：指定药店名单</span>
      </div> -->
      <img style="margin-top:20px" :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_10.png'" />
      <div class="fujian">
        <span class="line"></span><span>附件三：《关于公布第一批罕见病目录的通知》[国卫医发〔2018〕10号]</span>
      </div>
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_11.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_12.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_13.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_14.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_15.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_16.png'" />
      <img :src="cdnresources+'/prod/images/hunan2021/CPSMS_2021_17.png'" />
    </div>
  </div>
</template>

<script >
import { cdnresources } from '@/util/config'
export default {
  data() {
    return {
      cdnresources
    }
  },
  
}
</script>

<style lang="scss" scoped>
  img{
    width: 100%;
    height: 100%;
  }
  .page{
    background: #fff;
    .context{
      font-size: xvw(24);
      color: #696969;
      line-height: xvw(34);
      letter-spacing: xvw(1);
      .context-title{
        font-weight: 600;
        margin: xvw(30) 0 xvw(20);
      }
    }
    .fujian{
      display: flex;
      color: #696969;
      font-size: xvw(28);
      font-weight: 700;
      margin: xvw(40) 0 xvw(30);
      .line{
        width: xvw(4);
        height: xvw(28);
        background: #E73030;
        margin-right: xvw(10);
      }
    }
  }
  .centent{
    font-size: xvw(24);
    line-height: 24px;
    font-weight: 400;
    color: #666;
    white-space: pre-wrap;
    word-wrap: break-word;
    background: #fff;
  }
  .content-title{
    display: block;
    width:xvw(298);
    height:xvw(55);
    margin: xvw(30) 0 xvw(20);
  }
  
</style>
